import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { activity } from '../utils/api';

const ActivityTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const startedAt = Date.now();
    let sent = false;

    const recordTime = () => {
      if (sent) return;
      const durationSeconds = Math.round((Date.now() - startedAt) / 1000);
      if (durationSeconds < 5) return;
      sent = true;
      activity.track({
        eventType: 'page_time',
        durationSeconds,
        metadata: { path: location.pathname }
      }).catch(() => {});
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') recordTime();
    };

    window.addEventListener('pagehide', recordTime);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      recordTime();
      window.removeEventListener('pagehide', recordTime);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [location.pathname]);

  return null;
};

export default ActivityTracker;
